import { _, Backbone, Radio } from "../../vendor";
import { Biscuit } from "../utils";
import InboomaBaseController from "./InboomaBaseController";

import SalesBilling from "../models/SalesBilling";
import PaymentAccount from "../models/PaymentAccount";
import Transactions from "../collections/Transactions";
import Wallets from "../collections/Wallets";

import linksMap from "./FinancesControllerAccessBarMap";
import SalesBillingsView from "../views/orders/SalesBillings/SalesBillingsView";
import SalesBillingsSidebarView from "../views/orders/SalesBillings/SalesBillingsSidebarView";
import SalesBillingsSortTabsView from "../views/orders/SalesBillings/SalesBillingsSortTabsView";
import OffCanvasSalesBillingsForm from "../views/orders/SalesBillings/OffCanvasSalesBillingsForm";
import WalletsListView from "../views/myInbooma/finances/WalletsListView";
import WalletTransactionsListView from "../views/myInbooma/finances/WalletTransactionsListView";
import TransactionsSidebarView from "../views/myInbooma/finances/TransactionsSidebarView";
import TransactionsSortTabsView from "../views/myInbooma/finances/TransactionsSortTabsView";
import PaymentAccountsForm from "../views/myInbooma/finances/PaymentAccountForm";
import PaymentAccountsListView from "../views/myInbooma/finances/PaymentAccountsListView";
import PayoutForm from "../views/myInbooma/finances/PayoutForm";
import OffCanvasOrdersForm from "../views/orders/OffCanvasOrdersForm";

import SalesBillingsTpl from "../templates/orders/SalesBillings/SalesBillingsTpl.html";
import { isViewVisible } from "../utils/ViewSettings";

/**
 * This controller was re-named from "SalesBillingsController"
 * to "FinancesController" (see #20835)
 */
export default InboomaBaseController.extend({
  _el: "#inb-c-main-sales-billings",
  _channelName: "salesBillings",
  _template: SalesBillingsTpl,

  _modalViewMethods: {
    openOrdersForm: true,
  },

  _accessBarMap() {
    return {
      model: SalesBilling,
      collection: this.collection,
      pageTitle: this.t("my_account", null, "capital"),
      linksMap: linksMap(),
    };
  },

  index(options) {
    console.log("INDEX: ", options);

    let accessBar = document.getElementById("inb-main-menu");
    if (accessBar && accessBar.querySelector(".active") != null) {
      accessBar.querySelector(".active").classList.remove("active");
    }

    if (
      isViewVisible("transactions", "finances") === true &&
      document.location.href.indexOf("sales_billings") < 0
    ) {
      Backbone.history.navigate("finances/transactions", { trigger: true }); // navigate to transactions if accessible
      return;
    } else if (
      isViewVisible("salesBillings", "finances") !== true &&
      isViewVisible("paymentAccounts", "finances") === true
    ) {
      Backbone.history.navigate("finances/payment_accounts", { trigger: true }); // navigate to payment accounts if other tabs not accessible
      return;
    }

    if (typeof this.accessBar !== "undefined") this.accessBar.changeActiveLink("salesBillings");
    this.collection.resetFilters();
    this._resetOptions(options);

    this.layout.salesBillingsView = new SalesBillingsView({
      collection: this.collection,
      el: this.el,
      context: "finances/sales_billings",
    });

    this.layout.sidebarView = new SalesBillingsSidebarView({
      collection: this.collection,
      model: SalesBilling,
    });
    this.layout.sortTabsView = new SalesBillingsSortTabsView({
      collection: this.collection,
      model: SalesBilling,
    });
  },

  salesBillingsForm(id = null) {
    this.index();

    let model = null;

    if (id === null || id == "") {
      model = new SalesBilling();
    } else {
      let requestObject = new SalesBilling({ id: id });

      requestObject.fetch({
        async: false,
        success: (responseModel, response) => {
          model = responseModel;
        },
      });
    }

    if (typeof model !== "undefined") {
      const offCanvasSalesBillingsForm = new OffCanvasSalesBillingsForm({
        model,
        collection: this._collection,
      });
    } else {
      alert(this.t("unknown_or_removed_sales_billing"));
    }
  },

  transactions() {
    const wallets = Radio.channel("wallets").request("get:data");
    //transactions = Radio.channel('transactions').request('get:data');

    _.each(wallets.models, (wallet) => {
      // For now just set an empty collection as a filter call will be done
      // in TransactionsListView
      if (false === wallet.attributes.transactions instanceof Backbone.Collection) {
        wallet.set("transactions", new Transactions()); // new Transactions(transactions.where({ wallet_id : wallet.get('id') })));
      }
    });

    // ONLY TEMPORARY: We use Wallets-data to render WalletsList(Item);
    // however if wallets has more than one entry (as for manager-location)
    // we get into trouble -> pass a random wallet for now and let TransactionsListView
    // make use of GET /wallets_transactions for actual filtering
    const activeWallet = new Wallets(wallets.models[0]);

    this.layout.walletsListView = new WalletsListView({
      collection: activeWallet,
    });

    // Left the separation between walletsList- & transactionsListView
    // as it may be required later (walletListView-has-WalletTransactionsListView)
    this.layout.transactionsListView = new WalletTransactionsListView({
      collection: activeWallet.models[0].get("transactions"),
    });

    this.layout.transactionsSidebarView = new TransactionsSidebarView({
      collection: activeWallet.models[0].get("transactions"),
    });
    this.layout.transactionsSortTabsView = new TransactionsSortTabsView({
      collection: activeWallet.models[0].get("transactions"),
    });
  },

  paymentAccountForm(id) {
    const collection = Radio.channel("paymentAccounts").request("get:data");

    let model = null;

    if (id === "" || id === null) {
      model = new PaymentAccount({
        client_id: Number(Biscuit.get("user.client_id")),
      });
    } else {
      model = collection.get(id);
    }

    const paymentAccountsForm = new PaymentAccountsForm({
      collection,
      model,
    });

    return false;
  },

  payoutForm() {
    const transactions = Radio.channel("transactions").request("get:data");

    const payoutForm = new PayoutForm({
      transactions,
    });
  },

  payment_accounts() {
    const collection = Radio.channel("paymentAccounts").request("get:data");

    this.paymentAccountsList = new PaymentAccountsListView({
      collection,
    });
  },

  /**
   * Open orders form without leaving the active (transactionsList)-view
   * @todo this._shouldRenderLayout should return FALSE before calling this sub-method
   */
  openOrdersForm(orderId) {
    const that = this,
      orders = Radio.channel("orders").request("get:data");

    orders.fetchById(orderId, (order) => {
      if (!order) {
        // This will unlikely happen, but let's be prepared
        alert(`Sorry, but we could not find an order with ID "${orderId}".`);
        that.transactions();
        return;
      }

      const ordersForm = new OffCanvasOrdersForm({
        model: order,
        toggleAddReservation: false,
        collection: orders,
        context: "transactionsList",
      });

      ordersForm.afterCloseTriggerNavigate = false;
      ordersForm.parentView = "finances/transactions";
    });
  },
});
